export interface CpmCampaignLibraryLike {
  active_cpm_campaigns?: ReadonlyArray<unknown> | null;
}

/**
 * True when a library belongs to at least one active CPM campaign.
 *
 * This is the unlock signal for pro-only library-creation options in
 * `CopyLibraryDialog`: a free user remixing a CPM-campaign community library
 * gets the pro options. Pairs with `isPaidSubscription` — the dialog enables
 * controls when `isPaidPlan || libraryHasActiveCpmCampaign(library)`.
 */
export function libraryHasActiveCpmCampaign(
  library: CpmCampaignLibraryLike | null | undefined,
): boolean {
  return (library?.active_cpm_campaigns?.length ?? 0) > 0;
}
